<template>
    <div id="fp-nav" class="scroll-section-dots fp-right fixed left-0 z-30">
        <ul>
            <li>
                <a href="#">
                    <span class="fp-sr-only">Model X</span>
                    <span></span>
                </a>
            </li>
            <li>
                <a href="#">
                    <span class="fp-sr-only">Safety</span>
                    <span></span>
                </a>
            </li>
            <li>
                <a href="#">
                    <span class="fp-sr-only">Utility</span>
                    <span></span>
                </a>
            </li>
            <li>
                <a href="#">
                    <span class="fp-sr-only">Range</span>
                    <span></span>
                </a>
            </li>
            <li>
                <a href="#">
                    <span class="fp-sr-only">Autopilot</span>
                    <span></span>
                </a>
            </li>
            <li>
                <a href="#">
                    <span class="fp-sr-only">Performance</span>
                    <span></span>
                </a>
            </li>
            <li>
                <a href="#">
                    <span class="fp-sr-only">Interior</span>
                    <span></span>
                </a>
            </li>
            <li>
                <a href="#">
                    <span class="fp-sr-only">Exterior</span>
                    <span></span>
                </a>
            </li>
            <li>
                <a href="#">
                    <span class="fp-sr-only">Specs</span>
                    <span></span>
                </a>
            </li>
            <li>
                <a href="#">
                    <span class="fp-sr-only">Order</span>
                    <span></span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "SideScrollNav"
    }
</script>

<style scoped>

</style>